import styled from 'styled-components'

export const TileImageWrapper = styled.div`
  font-size:10px;
`